import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/auth/user.service';

@Component({
    selector: 'app-sidebar-left',
    templateUrl: './sidebar-left.component.html',
    styles: []
})
export class SideBarLeftComponent implements OnInit {
    constructor(
        private userService: UserService,
        private toastr: ToastrService
    ) { }

    userMenuAlones = [];
    userMenuParents = [];

    ngOnInit() {
        const isTechbyteAdmin = window.location.href.includes("/techbyte/admin")
        if (isTechbyteAdmin)
            this.userService.getUserMenu().subscribe(
                res => {
                    let result = <any>res;

                    this.userMenuAlones = result.listMenu.filter(x => !x.guidParent && !result.listMenu.some((c) => c.guidParent == x.guid));
                    this.userMenuParents = result.listMenu.filter(x => !x.guidParent && result.listMenu.some((c) => c.guidParent == x.guid));

                    for (const menuParent of this.userMenuParents) {
                        menuParent.Childs = result.listMenu.filter((x) => x.guidParent == menuParent.guid);

                        for (const menuChild of menuParent.Childs) {
                            menuChild.ChildChilds = result.listMenu.filter((x) => x.guidParent == menuChild.guid);
                        }
                    }
                },
                err => {
                    this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                },
            );
    }
}